<h6> <strong> Log details </strong> </h6>

<div class="table-responsive-sm" *ngIf="dataWithFilter.logList.length>0">
    <table class="table table-bordered">
        <tr>
            <th>Time Stamp </th>
            <th>Level</th>
            <th>Message </th>
            <th>Details</th>
        </tr>

        <tr *ngFor="let log of dataWithFilter.logList">
            <td>{{log.timeStamp | localDate:'dd-MMM-yy HH:mm:ss'}} </td>
            <td>{{log.level }}</td>
            <td>{{log.message | stringLimit}} </td>
            <td>
                <a (click)="viewLogDetails(log.id)"><img src="design/images/info.png" /></a>

            </td>
        </tr>
    </table>
</div>
<div *ngIf="dataWithFilter.logList.length==0" class="row p-3">
    <div class="col text-center text-dark">
        <p class="h6 font-weight-bold text-muted">No log to show!</p>
    </div>
</div>



<div class="row" *ngIf="dataWithFilter.logList.length>0">
    <div class="col-xs-10 col-10">
        <pagination [totalItems]="dataWithFilter.sortParameters.totalRecords"
            [itemsPerPage]="dataWithFilter.sortParameters.itemsPerPage" [maxSize]="20" [(ngModel)]="currentPage"
            (pageChanged)="pageChanged($event)"></pagination>
    </div>

    <div class="col-xs-2 col-2">
        <select (change)="onSelectChanges()" [(ngModel)]="dataWithFilter.sortParameters.itemsPerPage"
            class="form-control form-control-sm">
            <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
        </select>
        <p>Per page</p>
    </div>

</div>
